module.exports = __webpack_public_path__ + "static/media/vg-logo.5bcb058b.png";